import { AutoMap } from "@automapper/classes";

export class ELIMSProduct {
    @AutoMap()
    Eurodat5Code!: string
    @AutoMap()
    ProductDescription!: string
    @AutoMap()
    PartnerCode!: string
    @AutoMap()
    PartnerName!: string

}